<template>
  <div>
    <Loading :isActive="loading"></Loading>
    <CTabs variant="tabs" class="nav-tabs-boxed" :active-tab.sync="activeTab">
      <CTab title="Provedor & Modelos">
        <TabProvedor
          :parametro="parametro"
          @update="onUpdateParametro"
        />
      </CTab>

      <CTab title="Prompts">
        <TabPrompts
          :parametro="parametro"
          @update="onUpdateParametro"
        />
      </CTab>

      <CTab title="Dicionário">
        <TabDicionario />
      </CTab>

      <CTab title="Pré-Prompts">
        <TabPrePrompts />
      </CTab>

      <CTab title="Templates de análise">
        <div class="tab-templates-wrapper">
          <div class="info-alert">
            <CIcon name="cil-info" class="info-icon" />
            <div>
              <strong>Templates de Análise:</strong> modelos de prompt que definem como a IA deve estruturar resumos e análises de dados.
              Cada template contém instruções que orientam a IA sobre formato, tom e profundidade da análise gerada (ex: resumo de vendas, análise de desempenho, relatório de clientes inativos).
            </div>
          </div>
          <crud-base
            :url="templateUrl"
            :columns="templateColumns"
            :onDelete="() => {}"
            :onUpdate="() => {}"
            :onStore="() => {}"
            :enableSearch="true"
            :checkAlerts="true"
            primaryKey="id"
          />
        </div>
      </CTab>

      <CTab title="Log de Utilização">
        <TabLogUtilizacao />
      </CTab>
    </CTabs>

    <div class="footer-actions" v-if="activeTab < 2">
      <CButton
        color="primary"
        :disabled="saving"
        @click="salvarParametro"
      >
        {{ saving ? "Salvando..." : "Salvar Configurações" }}
      </CButton>
    </div>
  </div>
</template>

<script>
import { get, put } from "@/helpers/apiRequest";
import CrudBase from "../../components/crud/CrudBase";
import TabProvedor from "./TabProvedor.vue";
import TabPrompts from "./TabPrompts.vue";
import TabDicionario from "./TabDicionario.vue";
import TabPrePrompts from "./TabPrePrompts.vue";
import TabLogUtilizacao from "./TabLogUtilizacao.vue";

export default {
  name: "configuracao-ia",
  components: {
    CrudBase,
    TabProvedor,
    TabPrompts,
    TabDicionario,
    TabPrePrompts,
    TabLogUtilizacao,
  },
  data() {
    return {
      loading: false,
      saving: false,
      activeTab: 0,
      templateUrl: "/admin/template-resumo-ia",
      templateColumns: [
        { label: "Id", field: "id", sortable: false },
        { label: "Nome", field: "nome", sortable: false },
        { label: "Tipo", field: "tipo", sortable: false },
        { label: "Cadastrado por", field: "autor_nome", sortable: false },
      ],
      parametro: {
        tipo: "CHATGPT",
        token: "",
        model: "",
        model_tunado: "",
        model_para_audio: "",
        model_para_imagem: "",
        prompt_sugestao_pedido: "",
        prompt_contexto_negocio: "",
        itens_para_analise: 10,
        max_tokens_entrada: 10000,
      },
    };
  },
  methods: {
    loadParametro() {
      this.loading = true;
      get("/admin/parametros/GERAL_INTEGRACAO_IA_GENERATIVA")
        .then((json) => {
          if (json && json.valor) {
            const valor =
              typeof json.valor === "string"
                ? JSON.parse(json.valor)
                : json.valor;
            this.parametro = { ...this.parametro, ...valor };
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onUpdateParametro(changes) {
      this.parametro = { ...this.parametro, ...changes };
    },
    salvarParametro() {
      this.saving = true;
      put("/admin/parametros/GERAL_INTEGRACAO_IA_GENERATIVA", {
        chave: "GERAL_INTEGRACAO_IA_GENERATIVA",
        valor: this.parametro,
      })
        .then((json) => {
          this.saving = false;
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message || "Configurações atualizadas.",
            icon: "success",
            showConfirmButton: true,
          });
        })
        .catch((error) => {
          this.saving = false;
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message || "Erro ao salvar configurações.",
            icon: "error",
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
          });
        });
    },
  },
  mounted() {
    this.loadParametro();
  },
};
</script>

<style scoped>
.footer-actions {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #e4e7eb;
  background: #fff;
}

.tab-templates-wrapper {
  padding: 20px;
}

.info-alert {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  background: #edf8f9;
  border: 1px solid #c5e6e9;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #344054;
  line-height: 1.5;
}

.info-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #2298a3;
}
</style>
